import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container } from '@pella/sash-framework';
import { Breadcrumbs, Layout, SEO } from '../../components';
import { isValidArray } from '../../components/utilities/validations';

import LocalNavTop from '../../components/common/local-nav-top';
import DynamicComponent from '../../components/common/dynamic-component';
import Partner from '../../components/template/branch-partners/partner';

const BranchPartner = (props) => {
	const pageData = props.data.contentstackBranchPartners;

	return (
		<Layout id='template-BranchPartner'>
			{isValidArray(pageData.branch_data?.[0]?.local_nav) && (
				<LocalNavTop
					branchData={pageData?.branch_data?.[0]}
					linksArray={pageData?.branch_data?.[0].local_nav}
					currentUrl={pageData.url}
					isAnchors={false}
				/>
			)}

			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.hero && (
				<Container className='py-8 md:py-9 xl:py-10'>
					{pageData.hero.heading && <h1 className='text-h2 mb-2'>{pageData.hero.heading}</h1>}
					{pageData.hero.description && (
						<div
							className='text-subtitle'
							dangerouslySetInnerHTML={{ __html: pageData.hero.description }}
						/>
					)}
				</Container>
			)}

			{isValidArray(pageData.components) &&
				pageData.components.map((block, index) => {
					if (block.partner != null) {
						return (
							<Partner
								key={index}
								data={block.partner}
								className={index % 2 !== 0 ? 'bg-gray-3' : ''}
							/>
						);
					}

					if (block.dynamic != null) {
						return (
							<DynamicComponent
								key={index}
								data={block.dynamic}
								className='!bg-white'
							/>
						);
					}
				})}
		</Layout>
	);
};

BranchPartner.propTypes = {
	data: PropTypes.object.isRequired,
};

export default BranchPartner;

// eslint-disable-next-line react/prop-types -- gatsby component
export const Head = ({ data }) => <SEO {...data.contentstackBranchPartners.seo} />;

export const query = graphql`
	query ($uid: String!) {
		contentstackBranchPartners(id: { eq: $uid }) {
			url
			breadcrumbs {
				...Breadcrumbs
			}
			branch_data {
				...BranchData
			}
			hero {
				heading
				description
			}
			components {
				partner {
					logo {
						...Image
						image {
							url
							gatsbyImageData(quality: 90)
						}
					}
					heading
					description
					badge
					contact
					carousel {
						... on Contentstack_articles {
							...Article
						}
						... on Contentstack_image {
							...Image
						}
					}
				}
				dynamic {
					heading
					dynamic {
						...Dynamic
					}
				}
			}
			seo {
				...SEO
			}
		}
	}
`;
